import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Fade, Modal } from '@mui/material';
import SingleProduct from './SingleProduct';
import useStyles from './styles';
import Loader from '../../../../../commons/Loader';

export default function ProductModal({ modals, setOpenModal }) {
  const classes = useStyles();

  const handleModalClose = () => {
    setOpenModal('adminSingleProduct', false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modals.adminSingleProduct}
      closeAfterTransition
    >
      <Fade in={modals.adminSingleProduct}>
        <div className={classes.paper}>
          <div className={classes.topBarWrapper}>
            <div>
              <h2 id="transition-modal-title">
                Informations about product here
              </h2>
            </div>
            <IconButton
              color="secondary"
              aria-label="close"
              className={classes.closeButton}
              onClick={() => handleModalClose()}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <Loader target="singleProduct" size={32} centeredX centeredY>
            <SingleProduct />
          </Loader>
        </div>
      </Fade>
    </Modal>
  );
}

ProductModal.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
};
